module.exports = __webpack_public_path__ + "img/36.20decf97.jpeg";